export default __webpack_public_path__ + "static/media/brand2.09df75a6.svg";